import React from 'react';
import styles from './Tag.module.scss';

const Tag = ({ name, id, handleDeleteTag }) => (
  <button id={id} className={styles.bns3_tag} onClick={handleDeleteTag}>
    {name}
  </button>
);

export default Tag;
